<template>
    <div class="ui-circle-timer">
        <div class="ui-circle-timer__text"><slot /></div>
        <svg v-if="value">
            <circle :style="style" r="20" cx="22" cy="22"></circle>
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'ui-circle-timer',

        props: {
            value: {
                type: Number,
                default: 0
            }
        },

        computed: {
            style () {
                return {
                    animation: `countdown ${this.value}ms linear 1 forwards`
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .ui-circle-timer {
        position relative
        height 44px
        width 44px
        text-align center
        display flex
        align-items center
        justify-content center
        &__text {
            position relative
            z-index 2
            line-height 1
        }

        svg {
            position absolute
            z-index 1
            top 0
            right 0
            width 44px
            height 44px
            transform rotateY(-180deg) rotateZ(-90deg)
        }

        svg circle {
            stroke-dasharray 125px
            stroke-dashoffset 0
            stroke-linecap round
            stroke-width 3px
            stroke #C5E5FB
            fill none
        }
    }
</style>
<style lang="stylus" >
    @keyframes countdown {
        from {
            stroke-dashoffset 0
        }
        to {
            stroke-dashoffset 125px
        }
    }
</style>
